import axios from "axios";
const onboardingAPIKey = process.env.REACT_APP_ONBOARDING_API_KEY;
export const getAgentMembers = async (teamId) => {
  return fetch(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/TeamsManagement/agent/getAll?TeamId=${teamId}&PageSize=1000&PageNumber=1`,
  )
    .then((response) => response.json())
    .then((data) => data.result)
    .catch((error) => {
      console.error("Error fetching team members:", error);
      return [];
    });
};
export const getTeamLocation = async () => {
  return fetch(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/LocationManagement?PageNumber=1&PageSize=100`,
  )
    .then((response) => response.json())
    .then((data) => data.result)
    .catch((error) => {
      console.error("Error fetching team members:", error);
      return [];
    });
};
export const getTeamMembers = async () => {
  const data = await axios.get(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/OnboardingSetup/Teams/GetAll?PageSize=1000&PageNumber=1`,
  );
  return data.data.result;
};
export const getonBoardingEmployers = async () => {
  const data = await axios.get(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/EmployerManagement/EmployerDetails/GetAll?PageSize=100&PageNumber=1`,
    {
      headers: {
        Authorization: `${onboardingAPIKey}`,
      },
    },
  );
  return data?.data?.result;
};
export const getEmployerPortfolio = async (staffIds, locationId) => {
  const data = await axios.post(
    `https://pensionhub.nlpcpfa.com:8445/api/onboarding/api/RelationshipManagerAssignment/employer-portfolios`,
    {
      staffIds,
      locationId,
    },
  );
  return data?.data?.responseObject ?? null;
};
